import { render, staticRenderFns } from "./SelectFieldSearch.vue?vue&type=template&id=23cff51f&scoped=true&"
import script from "./SelectFieldSearch.vue?vue&type=script&lang=ts&"
export * from "./SelectFieldSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SelectFieldSearch.vue?vue&type=style&index=0&id=23cff51f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cff51f",
  null
  
)

export default component.exports